import { PassTier } from '@/services/account/types';

import { exhaustiveGuard } from './exhaustiveGuard';

const HUMANIZED_TIER_STRINGS = {
  [PassTier.DEFAULT]: 'Default',
  [PassTier.SINGLE_DAY_TICKET]: 'Single Day Ticket',
  [PassTier.MULTI_DAY_TICKET]: 'Multi-day Ticket',
  [PassTier.BRONZE_PASS]: 'Bronze Pass',
  [PassTier.SILVER_PASS]: 'Silver Pass',
  [PassTier.GOLD_PASS]: 'Gold Pass',
  [PassTier.PLATINUM_PASS]: 'Platinum Pass',
  [PassTier.SPECIAL_EVENT]: 'Special Event',
  [PassTier.GIFT_CERTIFICATE]: 'Gift Certificate',
  [PassTier.OTHER]: 'Other',
  [PassTier.DINE_CERTIFICATE]: 'Dine Certificate',
  [PassTier.RESERVATION]: 'Reservation',
  [PassTier.NON_ADMISSION]: 'Non-admission',
  [PassTier.FUN_CARD]: 'Fun Card',
  [PassTier.SEASON_PASS]: 'Season Pass',
  [PassTier.TRANSFERRABLE_PASS]: 'Transferrable Pass',
  [PassTier.COMP_PASS]: 'Comp Pass',
} as const satisfies Record<PassTier, string>;

type Keys = keyof typeof HUMANIZED_TIER_STRINGS;
export type HumanizeTierReturn = (typeof HUMANIZED_TIER_STRINGS)[Keys];

export function humanizeTier(tier: PassTier): HumanizeTierReturn {
  switch (tier) {
    case PassTier.DEFAULT:
    case PassTier.SINGLE_DAY_TICKET:
    case PassTier.MULTI_DAY_TICKET:
    case PassTier.BRONZE_PASS:
    case PassTier.SILVER_PASS:
    case PassTier.GOLD_PASS:
    case PassTier.PLATINUM_PASS:
    case PassTier.SPECIAL_EVENT:
    case PassTier.GIFT_CERTIFICATE:
    case PassTier.OTHER:
    case PassTier.DINE_CERTIFICATE:
    case PassTier.RESERVATION:
    case PassTier.NON_ADMISSION:
    case PassTier.FUN_CARD:
    case PassTier.SEASON_PASS:
    case PassTier.TRANSFERRABLE_PASS:
    case PassTier.COMP_PASS:
      return HUMANIZED_TIER_STRINGS[tier];

    default:
      return exhaustiveGuard(tier);
  }
}
